import { useMemo } from 'react';

import { useApartment } from '@stores/apartmentStore';
import {
  ApartmentProperties,
  parseApartmentProperties,
} from '@utils/apartmentUtils';

export const useApartmentProperties = (apartmentId?: string) => {
  const { apartment, isLoading } = useApartment(apartmentId);

  return useMemo<{ isLoading: boolean } & Partial<ApartmentProperties>>(() => {
    if (!apartment) return { isLoading };

    return {
      ...parseApartmentProperties(apartment),
      isLoading,
    };
  }, [apartment, isLoading]);
};
